import { render, staticRenderFns } from "./submission-failures-tab.vue?vue&type=template&id=6ff9d154"
import script from "./submission-failures-tab.vue?vue&type=script&lang=js"
export * from "./submission-failures-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports